import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "../LandingPage.module.css";
import { Typography } from "@mui/material";
import { useBreakpoints } from "../ResponsiveBreapoints";

const PrivacyPolicy = () => {
  const { IsXS } = useBreakpoints();

  const card1 = [
    {
      description: (
        <>
          We are pleased that you have chosen to visit the website,
          www.jpcapital.biz (the "Website" or the "Site"), operated by JP
          Capital LLC ("JP CAPITAL," "us," and "we"). JP CAPITAL respects your
          privacy and is committed to safeguarding the Personal Information you
          entrust to us as clients and visitors to our Site. This Privacy Policy
          governs how we collect and use Personal Information through this
          Website. It does not apply to information collected from other sources
          or in any other manner. This policy aims to inform you about:
          <ul style={{ paddingLeft: "30px", margin: 0 }}>
            <li>The types of information we collect.</li>
            <li>How we use and share collected information.</li>
            <li>Our measures to protect your information.</li>
            <li>How you can access, modify, or remove your information.</li>
          </ul>
          This Privacy Policy may be updated periodically, and we reserve the
          right to make changes without prior individual notice. Changes will
          take effect upon publication of the revised policy on the Site. Please
          review this Privacy Policy regularly to stay informed of our current
          practices. You are responsible for being aware of the most current
          version. The "updated" date at the top of the document indicates the
          last modification.
        </>
      ),
    },
    {
      title: "Collection of Information",
      description: (
        <>
          JP CAPITAL collects information in the following ways:
          <ul style={{ paddingLeft: "30px", margin: "0px 0px 20px 0px" }}>
            <li>
              Personal Information: This includes data that uniquely identifies
              you, such as your name, address, email address, and telephone
              number.
            </li>
            <li>
              We may also request additional information as required by laws and
              regulations governing the financial industry, including for
              Know-Your-Customer (KYC) and Anti-Money Laundering (AML)
              compliance.
            </li>
            <li>
              IP Address: When you access the Site, your internet service
              provider automatically assigns an IP (Internet Protocol) address
              to your computer. While generally not linked to your Personal
              Information, we may use IP addresses to identify individuals who
              threaten the Site, other users, or visitors. We also use IP
              addresses for site diagnostics and to gather broad demographic
              data, which is often anonymized
            </li>
            <li>
              Website Usage Information: As you navigate our Website, we
              automatically collect certain data regarding your usage,
              including:
              <ul style={{ paddingLeft: "30px" }}>
                <li>The date and time of access.</li>
                <li>Your computer's IP address.</li>
                <li>The domain and host from which you access the internet.</li>
                <li>Your browser software and operating system.</li>
                <li>The referring website address (if applicable).</li>
                <li>Your activities while on the Site.</li>
                <li>
                  This data helps us improve and enhance your Website experience
                  and is usually anonymized.
                </li>
              </ul>
            </li>
            <li>
              User Consent: By accessing and using the Website, you consent to
              the automatic collection of the above-mentioned information.
            </li>
          </ul>
        </>
      ),
    },
  ];
  const card2 = [
    {
      title: "Use of Your Personal Information",
      description: (
        <>
          We use your Personal Information, with your consent, for the purposes
          for which it is submitted, such as:
          <ul style={{ paddingLeft: "30px", margin: 0 }}>
            <li>Responding to your requests for information.</li>
            <li>Providing materials, information, and services.</li>
            <li>
              Notifying you about and resolving any service-related issues.
            </li>
            <li>Understanding the needs and interests of our customers.</li>
            <li>
              Analyzing the effectiveness of our products, services, and the
              Site.
            </li>
            <li>Managing the interactive features of the Site.</li>
            <li>Customizing the Site content and improving your experience.</li>
            <li>
              Providing information about potential client/consultant projects.
            </li>
            <li>
              Ensuring compliance with JP CAPITAL’s legal and regulatory
              obligations.
            </li>
            <li>Providing customer services and maintaining the Site.</li>
            <li>Investigating potential illegal activities.</li>
            <li>Any other purposes outlined in this Privacy Policy.</li>
            <li>
              Communicating with you about JP CAPITAL services that we believe
              may be of interest to you, as permitted by law.
            </li>
          </ul>
          We may also use your Personal Information to contact you via mail or
          electronically, with your consent, regarding your relationship with JP
          CAPITAL.
        </>
      ),
    },
    {
      title: "Opting Out of Communications",
      description:
        "You can opt out of future electronic communications from JP CAPITAL, such as emails, at any time by sending an email directly to info@jpcapital.ae.",
    },
    {
      title: "Do Not Track Signals",
      description:
        "Certain web browsers offer 'Do Not Track' signals. However, there is currently no uniform standard for these signals, and our Site does not respond to them. We may re-evaluate this in the event that an industry standard is developed and accepted.",
    },
    {
      title: "Data Transfer and Storage",
      description:
        "JP Capital LLC is based in Dubai, UAE. However, our servers and service providers may be located in other countries, which may have different data protection laws. By using our Site, you consent to the transfer of your personal information to these other jurisdictions, as necessary for the purposes outlined in this policy and as permitted by applicable law, including the UAE Personal Data Protection Law (UAE PDPL). We take measures to ensure your personal information is handled securely in accordance with applicable data protection laws, wherever it is processed.",
    },
    {
      title: "Sharing Information with Third Parties",
      description:
        "We may hire third-party companies to assist us with functions like data processing, website maintenance, transaction processing, marketing, customer service, and professional services (legal, accounting, etc.). We may share your Personal Information with these companies to perform services on our behalf, but require that they maintain the confidentiality of your Personal Information and comply with this policy. These companies only have access to the information necessary for their work and are prohibited from using it for any other purpose. We also provide our opt-out lists to third-party companies to prevent unwanted communications sent on JP CAPITAL’s behalf.",
    },
    {
      title: "Lawful Access, Legal Action, and Investigations",
      description:
        "We may disclose your Personal Information to third parties as required by, or to comply with, applicable laws and regulations. We may also disclose your information if we believe it necessary to investigate or prevent illegal activities, fraud, situations involving the physical safety of any person, violations of our Privacy Policy, or if otherwise required by law. For example, we may disclose your Personal Information to comply with investigations by regulatory authorities, to protect against fraud, or to protect JP CAPITAL’s rights, property, or safety.",
    },
    {
      title: "Cookies and Analytics",
      description: (
        <ul style={{ paddingLeft: "30px", margin: "0px" }}>
          <li>
            Cookies: Our Site may use "cookies" - small data files that we send
            to your computer. Cookies allow us to recognize when you return to
            our Site, track your preferences, and collect data about your online
            activity, such as web pages visited, links clicked, and searches
            conducted on our site. Cookies are stored in your browser or on your
            hard drive and can be retrieved by the website. You can manage
            cookies through your browser's settings, including deleting existing
            cookies, preventing new cookies, or disabling them altogether.
            However, please note that disabling cookies may affect some Website
            functionalities.
          </li>
          <li>
            Google Analytics: This Site uses Google Analytics, a web analytics
            tool that helps us understand how visitors use our website. Google
            Analytics collects anonymized information through cookies and IP
            addresses, reporting website trends without identifying individual
            visitors. For more information about Google Analytics, please visit{" "}
            <a
              href="https://www.google.com/analytics/learn/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.privacyPolicyLink}
            >
              https://www.google.com/analytics/learn/privacy.html
            </a>
            . You can opt-out of Google Analytics by installing the Google
            Analytics Opt-out Browser Add-on, available at:{" "}
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.privacyPolicyLink}
            >
              https://tools.google.com/dlpage/gaoptout?hl=en
            </a>
          </li>
        </ul>
      ),
    },
    {
      title: "Other Third-Party Services",
      description:
        "We use third-party services to understand user behavior and enhance the browsing experience on our Site. These services may include tools for user analytics and engagement tracking.",
    },
    {
      title: "Protection and Security of Information",
      description: (
        <>
          JP CAPITAL maintains reasonable standards of confidentiality and
          security for the Website and the Personal Information collected. We
          have implemented physical, technical, electronic, and managerial
          procedures to protect the security and integrity of your Personal
          Information. We secure Personal Information using industry-standard
          security technologies. In the event of a security breach that results
          in the unauthorized disclosure of Personal Information, JP CAPITAL
          will promptly notify affected consumers by posting information on the
          Website, and, if possible, by sending an email notification. <br />
          Please note that the security of online transactions cannot be
          guaranteed. To the fullest extent permitted by law, JP CAPITAL is not
          responsible for the misuse, loss, or unauthorized access to your
          Personal Information.
        </>
      ),
    },
    {
      title: "Links to other website and services",
      description:
        "Our Website may contain links to other websites or social media features ('other websites') that are not controlled by JP CAPITAL. These third-party sites may have different privacy policies. Please review the privacy policies of these other websites for information on their data collection and usage practices. JP CAPITAL is not responsible for the content or privacy practices of any linked sites.",
    },
    {
      title: "Governing law",
      description:
        "This Privacy Policy shall be governed by and construed in accordance with the laws of the United Arab Emirates and the Emirate of Dubai, without regard to its conflict of law provisions. Any dispute arising from this Privacy Policy, including its existence, validity, or termination, shall be subject to the exclusive jurisdiction of the competent courts of Dubai, UAE.",
    },
    {
      title: "Contact us",
      description: (
        <>
          If you have any questions or complaints regarding this Privacy Policy
          or our handling of your Personal Information, you may contact us by
          email at{" "}
          <span className={styles.privacyPolicyMail}>info@jpcapital.ae</span>.
        </>
      ),
    },
  ];
  return (
    <Grid container justifyContent="center">
      <Grid
        size={{ xs: 11, sm: 11, md: 11, lg: 8, xl: 7, xxl: 5 }}
        className={styles.contactContainer}
        ml={IsXS ? "" : 3}
      >
        <Grid container rowSpacing={2}>
          <Grid size={12} className={styles.centerItem}>
            <Typography className={styles.aboutUsTitle}>
              OUR COMMITMENT TO YOUR PRIVACY
            </Typography>
          </Grid>
          <Grid size={12} className={styles.centerItem}>
            <Typography className={styles.aboutUsHeading}>
              JP Capital LLC Privacy Policy
            </Typography>
          </Grid>
          {card1.map((data, index) => {
            return (
              <Grid key={index}>
                <Grid container>
                  <Grid>
                    <Typography className={styles.aboutUsTitle}>
                      {data.title}
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography className={styles.aboutUsDescription}>
                      {data.description}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
        <Grid container rowSpacing={2}>
          {card2.map((data, index) => {
            return (
              <Grid key={index}>
                <Grid container>
                  <Grid>
                    <Typography className={styles.aboutUsTitle}>
                      {data.title}
                    </Typography>
                  </Grid>
                  <Grid size={12}>
                    <Typography className={styles.aboutUsDescription}>
                      {data.description}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PrivacyPolicy;
